export default __webpack_public_path__ + "static/media/itachi.4ddd6d56.png";